import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SVG_DepositIcon from '../../assets/images/svgs/Deposit.svg?react';
import SVG_BacktIcon from '../../assets/images/svgs/chevronleft.svg?react';

const BottomDepositBar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="fixed bottom-0 w-full  lg:hidden bg-white">
            <div className=" flex flex-col shadow-lg autoAnimate">
                <div
                    id="bottomTabContainer"
                    className="w-full h-[42px] pr-[4px] flex items-center justify-between gap-1 bg-transparent   "
                >
                    <div id="logoContainer" className="logo flex w-full h-full md:w-fit ">
                        <div className=" flex items-center w-[40px] md:w-fit justify-center lg:hidden ">
                            <button
                                className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out w-8 h-6 flex ml-[4px] items-center bg-bg_Primary2 rounded-md justify-center active:scale-150  cursor-pointer"
                                type="button"
                                onClick={()=>{navigate(location.pathname.includes("livegames") ? -2 : -1);}}
                            >
                                <SVG_BacktIcon width={20} height={20} />
                            </button>
                        </div>
                    </div>
                    <div className=" md:w-max   flex items-center justify-center ml-auto lg:ml-0">
                        <div className=" flex justify-between items-center gap-x-1 h-max lg:hidden">
                            <button
                                type="button"
                                className=" leading-normal  transition duration-150 ease-in-out overflow-hidden relative active:scale-95 hidden xxs:flex items-center h-fit justify-center bg-bg_Success  rounded-md px-8 py-2 sm:px-4 sm:py-1.5 mr-[8px] text-text_Quaternary   text-sm   text-center  cursor-pointer "
                                onClick={() => {navigate('/deposit');}}
                            >
                                <span className="  font-semibold flex flex-row font-lato md:font-normal sm:text-base xs:text-sm">
                                    <span className="relative top-[2px] right-[3px]">
                                        <SVG_DepositIcon />
                                    </span>
                                    <span>Deposit</span>
                                </span>
                                <span className="shimmer"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BottomDepositBar;
